export default __webpack_public_path__ + "static/media/4e55400c07f4c35c990cf2b3cc648142.svg";